module.exports = __webpack_public_path__ + "img/sankt-leonhard-am-buchat_2017_ref.e050e34a.jpg";